module.exports = __webpack_public_path__ + "static/media/cdb25.e65d2841.png";